import $ from 'jquery';
import slider from '../slider/c-slider';

// default slider has no changes to the config
if ($('.default-slider').length > 0) {
    slider('default-slider');
}

// Style guide exmaple sliders
if ($('.eg-image-slider').length > 0 || $('.eg-generic-slider').length > 0) {
    // Accordion on click is only here because the Styleguide content is buried in an accordion. if we just initialise the sliders, because the accordion content is display: none, all the widths are busted. So wait until everything is visible to initialise them.
    $('.accordion-heading').on('click', () => {
        // Create the slider
        setTimeout(() => {
            slider('eg-image-slider');

            const tileSliderOpts = {
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 3
            };

            slider('eg-generic-slider', tileSliderOpts);
        }, 300);
    });
}
